import { useEffect } from "react";
import { Page } from "@iq/models";
import {
	TimeClockDayTimeline,
	TimeClockFilters,
	TimeClockRawEntries,
	TimeClockSummaryTable,
} from "../Components/TimeClock";
import useAdminTimeClockStore from "../states/useAdminTimeClockStore";
import "./TimeClock.css";

function TimeClock() {
	const filters = useAdminTimeClockStore((state) => state.filters);
	const teamMembers = useAdminTimeClockStore((state) => state.teamMembers);
	const entries = useAdminTimeClockStore((state) => state.entries);
	const summaryRows = useAdminTimeClockStore((state) => state.summaryRows);
	const timelineRows = useAdminTimeClockStore((state) => state.timelineRows);
	const loading = useAdminTimeClockStore((state) => state.loading);
	const hydrated = useAdminTimeClockStore((state) => state.hydrated);
	const error = useAdminTimeClockStore((state) => state.error);
	const setFilter = useAdminTimeClockStore((state) => state.setFilter);
	const hydrate = useAdminTimeClockStore((state) => state.hydrate);

	useEffect(() => {
		if (!hydrated) {
			hydrate();
		}
	}, [hydrate, hydrated]);

	useEffect(() => {
		if (!hydrated) {
			return undefined;
		}

		const timeoutId = window.setTimeout(() => {
			hydrate();
		}, 220);

		return () => {
			window.clearTimeout(timeoutId);
		};
	}, [
		hydrated,
		hydrate,
		filters.preset,
		filters.customFrom,
		filters.customTo,
		filters.userId,
		filters.focusDate,
	]);

	return (
		<Page>
			<div className="admin-time-clock-page">
				<div className="admin-time-clock-container">
					<div className="admin-time-clock-scroll">
						<TimeClockFilters
							filters={filters}
							teamMembers={teamMembers}
							loading={loading}
							onFilterChange={setFilter}
							onApply={hydrate}
						/>

						{error ? (
							<div className="form-error-message" role="alert">
								{error}
							</div>
						) : null}

						<TimeClockSummaryTable rows={summaryRows} />
						<TimeClockDayTimeline rows={timelineRows} focusDate={filters.focusDate} />
						<TimeClockRawEntries entries={entries} />
					</div>
				</div>
			</div>
		</Page>
	);
}

export default TimeClock;
